import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalDocumentType(props) {
  const documentType = props.model;

  return (
    <Modal
      title="Tipo documento"
      model={documentType}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/document-type"
    >
      <div>
        <TextField
          label="Código"
          type="text"
          fullWidth
          name="code"
          margin="normal"
          defaultValue={!!documentType ? documentType.code : ""}
          required
        />
      </div>
      <div>
        <TextField
          label="Abreviado"
          type="text"
          fullWidth
          name="description_short"
          margin="normal"
          defaultValue={!!documentType ? documentType.description_short : ""}
          required
        />
      </div>
      <div>
        <TextField
          label="Descripción"
          type="text"
          fullWidth
          name="description"
          margin="normal"
          defaultValue={!!documentType ? documentType.description : ""}
          required
        />
      </div>
    </Modal>
  );
}
